import { ButtonProps } from "@headlessui/react";
import clsx from "clsx";

const SortingButton: React.FC<
  ButtonProps & {
    onClick: () => void;
    isSelected: boolean;
    children: React.ReactNode;
  }
> = ({ isSelected, children, onClick }) => {
  return (
    <button
      onClick={onClick}
      className={clsx(
        "p-2 gap-2 border relative homepage-text-sm",
        isSelected
          ? "text-[var(--filter-button-active-text-color)] bg-[var(--filter-button-active-bg-color)] border-[var(--filter-button-active-border-color)]"
          : "text-[var(--filter-button-text-color)] hover:text-[var(--filter-button-active-text-color)] hover:bg-[var(--filter-button-active-bg-color)] hover:border-[var(--filter-button-active-border-color)] bg-[var(--filter-button-bg-color)] border-[var(--filter-button-border-color)]"
      )}
    >
      {children}
    </button>
  );
};

export default SortingButton;
